<div class="card">
    <!-- <img src="{{ nosotrosCardObject.imgUrl }}" alt="" class="card-photo"> -->
    <h3 class="name">{{ nosotrosCardObject.name }}</h3>
    <h4 class="position">{{ nosotrosCardObject.position}}<br>Nº Socio: {{ nosotrosCardObject.number }}</h4>
</div>
